import React from "react";
import { IonTitle } from "@ionic/react";
import { Capacitor } from "@capacitor/core";
import { IHeaderTitle } from "@interfaces/Components";
import classNames from "classnames";

type HeaderTitleProps = IHeaderTitle & {
  collapsible?: boolean;
};

const HeaderTitle: React.FC<HeaderTitleProps> = (props) => {
  return (
    <IonTitle
      style={{
        height: Capacitor.getPlatform() === "android" ? "54px" : "44px",
      }}
      className={classNames({
        "header-title-content": props.collapsible,
      })}
    >
      {props.children}
    </IonTitle>
  );
};

export default HeaderTitle;
